__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "container";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@azure/msal-browser", "4.20.0", () => (__webpack_require__.e(580).then(() => (() => (__webpack_require__(7561))))));
			register("@azure/msal-react", "3.0.18", () => (Promise.all([__webpack_require__.e(580), __webpack_require__.e(751), __webpack_require__.e(576)]).then(() => (() => (__webpack_require__(6810))))));
			register("@express-portal/design-system", "1.0.30", () => (Promise.all([__webpack_require__.e(569), __webpack_require__.e(96), __webpack_require__.e(751), __webpack_require__.e(660), __webpack_require__.e(440)]).then(() => (() => (__webpack_require__(772))))));
			register("@mui/material", "7.3.1", () => (Promise.all([__webpack_require__.e(569), __webpack_require__.e(96), __webpack_require__.e(751), __webpack_require__.e(660), __webpack_require__.e(929)]).then(() => (() => (__webpack_require__(5152))))));
			register("@tanstack/react-query", "5.90.17", () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(751), __webpack_require__.e(660)]).then(() => (() => (__webpack_require__(2040))))));
			register("launchdarkly-react-client-sdk", "3.9.1", () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(751)]).then(() => (() => (__webpack_require__(3545))))));
			register("react-dom", "19.2.1", () => (Promise.all([__webpack_require__.e(411), __webpack_require__.e(751)]).then(() => (() => (__webpack_require__(961))))));
			register("react-router-dom", "7.12.0", () => (Promise.all([__webpack_require__.e(411), __webpack_require__.e(96), __webpack_require__.e(751), __webpack_require__.e(929)]).then(() => (() => (__webpack_require__(118))))));
			register("react/jsx-runtime", "19.2.1", () => (__webpack_require__.e(411).then(() => (() => (__webpack_require__(4848))))));
			register("react", "19.2.1", () => (__webpack_require__.e(411).then(() => (() => (__webpack_require__(6540))))));
			initExternal(5859);
			initExternal(1878);
			initExternal(7247);
			initExternal(0);
			initExternal(8269);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};